import React, { Suspense, lazy } from 'react';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { headerHeight } from 'config/style';
import { Scroll, Loader, Alert } from 'components';
import routes from 'config/routes';
import { useReduxSelector } from 'store/hooks';
import { Typography } from '@material-ui/core';

const NotFoundPage = lazy(() => import('./NotFoundPage'));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.default,
    backgroundColor: '#f1f3f4',
    paddingTop: 0,
  },
  content: {
    padding: '15px',
    minHeight: `calc(100vh - ${headerHeight}px)`,
  },
}));

const Content = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const account = useReduxSelector((state) => state.account);
  const app = useReduxSelector((state) => state.app);

  let enabledRoutes = routes;

  if (!(account.data.isHR || account.data.isSPV || account.data.access)) {
    if (app.env.projectId === 'atmost-cibinong') {
      enabledRoutes = [
        ...routes.filter((route) => ['shift'].includes(route.id)),
        {
          redirect: true,
          from: '/',
          to: '/shift',
        },
      ];
    } else {
      return (
        <div className={classes.root}>
          <div style={{ marginTop: headerHeight }} />
          <Typography
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: 10,
              textAlign: 'center',
            }}
          >
            Anda tidak memiliki hak akses untuk membuka halaman admin.
          </Typography>
        </div>
      );
    }
  }

  if (
    account.data?.inChargeDivision &&
    account.data.inChargeDivision?.includes('Mahasiswa') &&
    account.data.isHR
  ) {
    enabledRoutes = [
      ...routes.filter((route) => ['user', 'shift', 'dashboard', 'transaction', 'devices'].includes(route.id)),
      {
        redirect: true,
        from: '/',
        to: account.data.isHR ? '/user' : '/transaction',
      },
    ];
  }

  if (Array.isArray(account.data.adminPrivileges) || (!account.data.isHR && account.data.isSPV)) {
    enabledRoutes = [
      ...routes.filter(
        (item) => account.data.adminPrivileges?.includes(item.id) || item.access?.includes('SPV')
      ),
      {
        redirect: true,
        from: '/',
        to: account.data.isHR ? '/user' : '/transaction',
      },
    ];
  }

  if (account.data?.isDirectors) {
    enabledRoutes = [
      ...routes.filter((route) => ['dashboard'].includes(route.id)),
      {
        redirect: true,
        from: '/',
        to: '/dashboard',
      },
    ];
  }

  return (
    <div className={classes.root}>
      <div style={{ marginTop: headerHeight }} />
      <Scroll height={`calc(100vh - ${headerHeight}px)`} type="body" location={location}>
        <main className={classes.content} id="content">
          <Suspense fallback={<Loader variant="fade" height="page" />}>
            <Switch>
              {enabledRoutes.map((item, key) =>
                item.redirect ? (
                  <Redirect from={item.path} to={item.to} key={key} />
                ) : item.sub ? (
                  item.sub.map((subitem) => (
                    <Route path={item.path + subitem.path} component={subitem.component} />
                  ))
                ) : (
                  <Route path={item.path} component={item.component} key={key} />
                )
              )}
              <Route component={NotFoundPage} />
            </Switch>
          </Suspense>
          <Alert />
        </main>
      </Scroll>
    </div>
  );
};

export default Content;
